var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdm = function SvgEdm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.715 14.285a1.928 1.928 0 1 0 0 3.857 1.928 1.928 0 0 0 0-3.857Zm0 2.572a.643.643 0 1 1 0-1.287.643.643 0 0 1 0 1.287Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.786v12.857c0 .71.575 1.286 1.286 1.286h15.428c.71 0 1.286-.576 1.286-1.286V9.786c0-.71-.575-1.286-1.286-1.286H8.286C7.576 8.5 7 9.075 7 9.786Zm1.929 12.857a.643.643 0 1 1 0-1.286.643.643 0 0 1 0 1.286ZM14.714 22a5.785 5.785 0 1 1 0-11.57 5.785 5.785 0 0 1 0 11.57Zm9-9.964a.322.322 0 0 1-.321.321h-.322v7.182c0 .515-.2 1-.565 1.364l-.909.909a.642.642 0 1 1-.909-.91l.91-.908a.646.646 0 0 0 .188-.455v-7.182h-.322a.322.322 0 0 1-.321-.321v-1.929c0-.177.144-.321.321-.321h1.929c.177 0 .321.144.321.321v1.929Z",
    fill: "#fff"
  })));
};
export default SvgEdm;